import { get, patch, post, toQueryString } from '../axios'
import { candidate, CandidateQuery } from './candidate'
import { missedCandidate } from './missed-candidate'
import { StoreInput } from './input/store-input'
import { ArchiveInput } from './input/archive-input'
import { z } from 'zod'
import { UpdateColumnInput } from './input/update-column-input'
import { UnarchiveInput } from './input/unarchive-input'
import { paginated } from '../zod/pagination'

export function fetchCandidate(candidateId: string) {
    return get(candidate, `/candidates/${candidateId}`)
}

export function fetchCandidates({ query }: { query?: CandidateQuery } = {}) {
    return get(paginated(candidate), `/candidates?${toQueryString(query || {})}`)
}

export function storeCandidate(campaignId: string) {
    return (input: StoreInput) => post(candidate, `/campaigns/${campaignId}/candidates`, input)
}

export function archiveCandidate(input: ArchiveInput) {
    return post(z.string(), `/candidates/archive`, input)
}

export function rejectCandidate(candidateId: string, input: { messageTemplateId: string }) {
    return post(z.string(), `/candidates/${candidateId}/reject`, input)
}

export function unarchiveCandidate(input: UnarchiveInput) {
    return post(z.string(), `/candidates/unarchive`, input)
}

export function bulkStoreCandidate(campaignId: string) {
    return (input: { candidates: StoreInput[] }) => post(z.string(), `/campaigns/${campaignId}/candidates/bulk`, input)
}

export function fetchMissedCandidates(campaignId: string, query?: { page?: number; size?: number }) {
    return get(paginated(missedCandidate), `/campaigns/${campaignId}/missed-candidates?${toQueryString(query || {})}`)
}

export function retryMissedCandidate(campaignId: string, missedCandidateId: string) {
    return (input: StoreInput) =>
        post(candidate, `/campaigns/${campaignId}/missed-candidates/${missedCandidateId}/retry`, input)
}

export function resolveMissedCandidate(campaignId: string, missedCandidateId: string) {
    return (input: { candidateId: string }) =>
        patch(missedCandidate, `/campaigns/${campaignId}/missed-candidates/${missedCandidateId}/resolve`, input)
}

export function updateCandidateColumn(candidateId?: string) {
    return (input: UpdateColumnInput & { candidateId?: string }) =>
        patch(candidate, `/candidates/${candidateId || input.candidateId}/column`, input)
}

export function updateCandidateCompanyColumn(candidateId?: string) {
    return (input: UpdateColumnInput & { candidateId?: string }) =>
        patch(candidate, `/candidates/${candidateId || input.candidateId}/company-column`, input)
}
